const DEFAULT_CODE = 'unknown_error';
const DEFAULT_MESSAGE = 'Ocurrió un error inesperado. Probá de nuevo.';

/**
 * Normalized client-side representation of an API failure. The server always
 * responds with `{ error: { code, message } }` (see
 * docs/superpowers/specs/2026-09-25-cliente-login-paneles-design.md); this
 * class turns that envelope into something UI code can branch on (`code`)
 * and display (`message`) without ever showing raw exception text.
 */
export class ApiError extends Error {
  constructor(status, code, message) {
    super(message || DEFAULT_MESSAGE);
    this.name = 'ApiError';
    this.status = status;
    this.code = code || DEFAULT_CODE;
  }

  /**
   * Builds an ApiError from a fetch Response's status plus its (already
   * parsed, possibly null/malformed) JSON payload.
   */
  static fromResponse(status, payload) {
    const envelope = payload && typeof payload === 'object' ? payload.error : null;
    const code = envelope && typeof envelope.code === 'string' && envelope.code
      ? envelope.code
      : DEFAULT_CODE;
    const message = envelope && typeof envelope.message === 'string' && envelope.message
      ? envelope.message
      : DEFAULT_MESSAGE;
    return new ApiError(status, code, message);
  }
}
